@if (loading) {
  <div class="d-flex flex-grow-1 flex-column my-5 align-content-center justify-content-center">
    <p-progress-spinner ariaLabel="loading" />
  </div>
} @else {

  <h3 class="country-title text-center text-sm-start">{{ translations.select_country }}</h3>

  <div class="d-grid">
    <div class="row">
      @for (country of countries; track country.countryCode) {
        <button
          type="button"
          class="country-card col-xl-2 col-lg-2 col-md-3 col-sm-4 col-xs-6 mb-4"
          (click)="goToCountry(country)"
        >
          <img
            [src]="country.img"
            [alt]="country.countryName"
          />

          <span>{{ country.countryName }}</span>
        </button>
      }
    </div>
  </div>

  <div class="mt-5 text-center">

    <h3 class="qr-title">{{ translations.scan_qr }}</h3>

    @if (walletLoading()) {
      <p-progress-spinner ariaLabel="loading" />
    } @else if (authorizationRequestUri()) {

      <qrcode
        [qrdata]="authorizationRequestUri()"
        [width]="280"
        [errorCorrectionLevel]="'M'">
      </qrcode>

    }

  </div>

}
